// extracted by mini-css-extract-plugin
export default {"mCard":"UA-z","image":"VA-z","imageNoBackground":"WA-z","imageHasCategory":"XA-z","fullWidth":"YA-z"};